import wretch from "wretch";
import QueryStringAddon from "wretch/addons/queryString";
import {
  ISubmitSlotSelectionPayload,
  ISubmitSlotSelectionResponse
} from "./slotSelection.types";
import { ISection } from "services/api/packages/packageDetails.types";

const BASE_URL = `${process.env.NEXT_PUBLIC_BASE_API}`;

export const selectSlots = (
  payload: ISubmitSlotSelectionPayload,
  token: string
): Promise<ISubmitSlotSelectionResponse> => {
  return wretch(`${BASE_URL}/sessions/v1/slot-selection/select-slots`)
    .auth(`Bearer ${token}`)
    .post(payload)
    .json();
};

export const getCoursesWithBatches = (
  courseIds: string[],
  token: string
): Promise<{ data: { sections: ISection[] } }> => {
  const params = new URLSearchParams(
    courseIds.map((id) => ["course_ids[]", id])
  );
  return wretch(`${BASE_URL}/sessions/v1/slot-selection/courses-with-batches`)
    .addon(QueryStringAddon)
    .auth(`Bearer ${token}`)
    .query(params.toString())
    .get()
    .json();
};
